export default __webpack_public_path__ + "static/media/1-Cloudxier-IntiMasSejahtera-Website.7bc97115.png";